// ============================================================================
// dataTypes/liveStreamManagment/sourceRegistry/acquirers/RemoteAcquirer.ts
// Gère les sources WebRTC distantes (caméras smartphones).
//
// Contrairement aux autres acquirers, le stream n'est PAS acquis par
// l'acquirer lui-même. C'est la couche de signalisation qui le produit
// (via ontrack de la PeerConnection) et l'injecte dans le registry
// via registry.injectStream(sourceId, stream).
//
// acquire() ici attend simplement que le stream soit injecté.
// release() ne stoppe PAS les tracks (on ne possède pas le flux distant).
// ============================================================================

import { Source, SourceAcquirer } from '../types';

export class RemoteAcquirer implements SourceAcquirer {

  /**
   * Pour une source remote, le stream est injecté par la signalisation.
   * Si le stream est déjà présent (injecté avant l'appel à acquire),
   * on le retourne directement.
   *
   * Sinon, on lève une erreur — c'est le rôle de la signalisation
   * d'appeler registry.injectStream() quand la PeerConnection produit
   * un stream, AVANT que quiconque appelle acquire().
   */
  async acquire(source: Source): Promise<MediaStream> {
    if (source.stream) {
      return source.stream;
    }
    throw new Error(
      `[RemoteAcquirer] Le stream pour "${source.id}" n'a pas encore été injecté ` +
      `par la signalisation. Utilisez registry.injectStream() d'abord.`
    );
  }

  /**
   * Ne stoppe PAS les tracks — on ne possède pas le flux distant.
   * La PeerConnection et la signalisation gèrent leur propre cycle de vie.
   */
  release(_source: Source): void {
    // Intentionnellement vide.
    // Le stream distant est géré par la couche signalisation/PeerConnection.
  }
}
